import React, { useEffect } from 'react';
import { pathname } from '../../../utils';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useLinesContext } from '../../../contexts/Lines';
import { getProducts, SortDirections, getLines } from '../../API';
import { useCompanyContext } from '../../../contexts/Company';

interface CheckServerParams {
  fetchLines?: boolean;
}

export default function CheckServer({ fetchLines = false }: CheckServerParams) {
  const { setActiveStep, setLoading } = useOnboardingContext();
  const { business, getUserCompany } = useCompanyContext();
  const { products, setProducts, lines, setLines } = useLinesContext();

  async function getProductsInfo() {
    try {
      const products = await getProducts('updated_at', SortDirections.asc);
      setProducts(products);
    } catch {
      setProducts([]);
    }
  }

  async function getLinesInfo() {
    try {
      const lines = await getLines();
      setLines(lines);
    } catch {
      setLines([]);
    }
  }

  async function getOnboardingInfo() {
    const missingOnboardingInfo = [];
    if (!business) missingOnboardingInfo.push(getUserCompany());
    if (!products) missingOnboardingInfo.push(getProductsInfo());
    if (fetchLines && !lines) missingOnboardingInfo.push(getLinesInfo());
    if (missingOnboardingInfo.length > 0) {
      setLoading(true);
      await Promise.all(missingOnboardingInfo);
      setLoading(false);
    }
  }

  function setOnboardingStep() {
    const onboardingPages = Object.values({
      ...pathname.onboarding.main,
      ...pathname.onboarding.extras,
    });
    let currentPage = onboardingPages.find(
      (page) => page.url === window.location.pathname,
    );
    if (currentPage) {
      setActiveStep(currentPage['stepInStepper']);
    }
  }

  useEffect(() => {
    if (!products || !business || !lines) {
      getOnboardingInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setOnboardingStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
}
